import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  getIsVerified,
  setIsVerified as setIsVerifiedStorage,
  getIsFillProfile,
  setIsFillProfile as setIsFillProfileStorage,
  getHasVek,
  setHasVek as setHasVekStorage
} from "./verificationStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isVerified, setIsVerified] = useState(() => getIsVerified());

  const [isFillProfile, setIsFillProfile] = useState(() => getIsFillProfile());

  // Есть ли у пациента карты профосмотра ВЭК (HAS_VEK из get_user_data):
  // true / false, либо null - ещё не спрашивали (см. verificationStorage)
  const [hasVek, setHasVek] = useState(() => getHasVek());

  const [isShowWarning, setIsShowWarning] = useState(false);
  const [messageWarning, setMessageWarning] = useState({
    title: '',
    description: ''
  });

  useEffect(() => {
    setIsVerifiedStorage(isVerified);
  }, [isVerified]);

  useEffect(() => {
    setIsFillProfileStorage(isFillProfile);
  }, [isFillProfile]);

  useEffect(() => {
    setHasVekStorage(hasVek);
  }, [hasVek]);

  const resetUserSession = () => {
    setIsVerified(false);
    setIsFillProfile(false);
    // null, а не false: при следующем заходе на /main флаг будет перезапрошен
    setHasVek(null);

    localStorage.removeItem('isVerified');
    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('hasVek');
    localStorage.removeItem('email');
  }

  const value = useMemo(
    () => ({
      isVerified,
      setIsVerified,
      isFillProfile,
      setIsFillProfile,
      hasVek,
      setHasVek,
      isShowWarning,
      setIsShowWarning,
      messageWarning,
      setMessageWarning,
      resetUserSession
     }),
    [isVerified, isFillProfile, hasVek, isShowWarning, messageWarning]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
